import magnetic from "./images/mockups/holly-magnetic.png";
import magnetic_white from "./images/mockups/holly-magnetic-white.png";
import magnetic_1 from "./images/studio/holly-magnetic-1.png";
import magnetic_2 from "./images/studio/holly-magnetic-2.png";
import jade from "./images/mockups/holly-jade.png";
import jade_white from "./images/mockups/holly-jade-white.png";
import jade_1 from "./images/studio/holly-jade-1.png";
import jade_2 from "./images/studio/holly-jade-2.png";
import divinity from "./images/mockups/holly-divinity.png";
import divinity_white from "./images/mockups/holly-divinity-white.png";
import divinity_1 from "./images/studio/holly-divinity-1.png";
import divinity_2 from "./images/studio/holly-divinity-2.png";
import becoming from "./images/mockups/holly-becoming.png";
import becoming_white from "./images/mockups/holly-becoming-white.png";
import becoming_1 from "./images/studio/holly-becoming-1.png";
import becoming_2 from "./images/studio/holly-becoming-2.png";

import evolution01 from "./images/mockups/holly-evolution-01.png";
import evolution01_white from "./images/mockups/holly-evolution-01-white.png";
import evolution01_1 from "./images/studio/holly-evolution-01-1.png";
import evolution01_2 from "./images/studio/holly-evolution-01-2.png";
import evolution01_3 from "./images/studio/holly-evolution-01-3.png";
import evolution02 from "./images/mockups/holly-evolution-02.png";
import evolution02_white from "./images/mockups/holly-evolution-02-white.png";
import evolution02_1 from "./images/studio/holly-evolution-02-1.png";
import evolution02_2 from "./images/studio/holly-evolution-02-2.png";
import evolution02_3 from "./images/studio/holly-evolution-02-3.png";
import evolution_collection from "./images/mockups/holly-evolution-collection.png";
import evolution_collection_white from "./images/mockups/holly-evolution-collection-white.png";
import evolution_collection_1 from "./images/studio/holly-evolution-collection-1.png";
import evolution_collection_2 from "./images/studio/holly-evolution-collection-2.png";
import evolution_collection_3 from "./images/studio/holly-evolution-collection-3.png";
import evolution_collection_4 from "./images/studio/holly-evolution-collection-4.png";
import { Profile } from "../profile";

// Create the person first
const artist = new Profile("holly");
artist.insta = "hollymillea";
artist.description = `"Being a software developer and also having a creative side, I like to explore the intersection of the two, creating visuals from nothing but code entirely. These pieces have not been touched or edited, purely created from mathematical functions and randomness. Each design is completely unique."`
// artist.description2 = "Holly’s work explores the meeting point between art and technology, created entirely through code. Drawing on geometry, mathematical functions, and elements of randomness, she builds visual systems that unfold in unexpected ways. The results feel fluid and human, each piece taking on its own unique form.";
artist.descriptionExtended = "TEST";

const details = `Digital print on 300gsm recycled paper.
    Open edition (Unframed).
    Free UK postage only (Standard 5-10 working days).`;


// Create the sections and items
artist.createSection("line work.");

artist.createItem("BECOMING");
artist.setMockup(becoming);
artist.addImage(becoming_white);
artist.addImage(becoming_1);
artist.addImage(becoming_2);
artist.addSizeAndPrice("30x40cm", 30, "price_1SUPIQ2LxEhI4RHCTlgbmAFK");
artist.addDetails(details);
artist.setId("holly-becoming");
artist.addTestPriceId("price_1SUOvi2LxEhI4RHCJ2vhvxH8");
artist.addDescription(`"This collection came from my first exploration into generative art, i.e using nothing but words and code to generate something visual. Here I have manipulated random noise data to generate smooth flowing lines that move together to create unique abstract forms.
    Due to the random nature of noise data, each time the code runs the output is completely different - meaning designs are unique and nothing can be reproduced. This collection is a selection of my favourite generations from this process."`);

artist.createItem("JADE");
artist.setMockup(jade);
artist.addImage(jade_white);
artist.addImage(jade_1);
artist.addImage(jade_2);
artist.addSizeAndPrice("30x40cm", 30, "price_1SUPI82LxEhI4RHCmeInanX2");
artist.addDetails(details);
artist.setId("holly-jade");
artist.addTestPriceId("price_1SUOvY2LxEhI4RHCEN4Prz0p");
artist.addDescription(`"This collection came from my first exploration into generative art, i.e using nothing but words and code to generate something visual. Here I have manipulated random noise data to generate smooth flowing lines that move together to create unique abstract forms.
    Due to the random nature of noise data, each time the code runs the output is completely different - meaning designs are unique and nothing can be reproduced. This collection is a selection of my favourite generations from this process."`);


artist.createItem("MAGNETIC");
artist.setMockup(magnetic);
artist.addImage(magnetic_white);
artist.addImage(magnetic_1);
artist.addImage(magnetic_2);
artist.addSizeAndPrice("30x40cm", 30, "price_1SUPHm2LxEhI4RHCbe57GhRX");
artist.addDescription("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc eu orci purus. Nullam blandit est felis, eu fermentum risus suscipit sit amet. Vestibulum finibus pharetra faucibus. Vestibulum consequat odio at est blandit elementum. In hac habitasse platea dictumst.");
artist.setStock(4);
artist.addDetails(details);
artist.setId("holly-magnetic");
artist.addTestPriceId("price_1SUOvu2LxEhI4RHCYHPNDy8W");
artist.addDescription(`"This collection came from my first exploration into generative art, i.e using nothing but words and code to generate something visual. Here I have manipulated random noise data to generate smooth flowing lines that move together to create unique abstract forms.
    Due to the random nature of noise data, each time the code runs the output is completely different - meaning designs are unique and nothing can be reproduced. This collection is a selection of my favourite generations from this process."`);

artist.createItem("DIVINITY");
artist.setMockup(divinity);
artist.addImage(divinity_white);
artist.addImage(divinity_1);
artist.addImage(divinity_2);
artist.addSizeAndPrice("30x40cm", 30, "price_1SUPHw2LxEhI4RHCJghcAiOt");
artist.addDetails(details);
artist.setId("holly-divinity");
artist.addTestPriceId("price_1SUOw92LxEhI4RHCah5nK7j9");
artist.addDescription(`"This collection came from my first exploration into generative art, i.e using nothing but words and code to generate something visual. Here I have manipulated random noise data to generate smooth flowing lines that move together to create unique abstract forms.
    Due to the random nature of noise data, each time the code runs the output is completely different - meaning designs are unique and nothing can be reproduced. This collection is a selection of my favourite generations from this process."`);

artist.createSection("graffiti.");

artist.createItem("EVOLUTION 01");
artist.setMockup(evolution01);
artist.addImage(evolution01_white);
artist.addImage(evolution01_1);
artist.addImage(evolution01_2);
artist.addImage(evolution01_3);
artist.addSizeAndPrice("A5 (14.8x21.0cm)", 18, "price_1SSbrh2LxEhI4RHCV8f1mD4a");
artist.addDetails(details);
artist.setId("holly-evolution-01");
artist.addTestPriceId("price_1SL8p12LxEhI4RHCMKFv84Sm");
artist.addDescription(`"This piece was created when I was experimenting with trying to create a 'graffiti-like' effect from something digital. It has been fully created using code (specifically the programming language JavaScript - no, not AI !). 
    I used random noise data, called Perlin noise, and a lot of Maths to generate unique patterns in which the lines flow. The 4 sections show how the noise moves over time, 4 seconds apart, showing how a line may naturally move on its own (hence EVOLUTION)."`);

artist.createItem("EVOLUTION 02");
artist.setMockup(evolution02);
artist.addImage(evolution02_white);
artist.addImage(evolution02_1);
artist.addImage(evolution02_2);
artist.addImage(evolution02_3);
artist.addSizeAndPrice("A5 (14.8x21.0cm)", 18, "price_1SSbvc2LxEhI4RHCHHPRH0a7");
artist.addDetails(details);
artist.setId("holly-evolution-02");
artist.addTestPriceId("price_1SLn4o2LxEhI4RHCzlUBwNn2")
artist.addDescription(`"This piece was created when I was experimenting with trying to create a 'graffiti-like' effect from something digital. It has been fully created using code (specifically the programming language JavaScript - no, not AI !). 
    I used random noise data, called Perlin noise, and a lot of Maths to generate unique patterns in which the lines flow. The 4 sections show how the noise moves over time, 4 seconds apart, showing how a line may naturally move on its own (hence EVOLUTION)."`);

artist.createItem("EVOLUTION COLLECTION");
artist.setMockup(evolution_collection);
artist.addImage(evolution_collection_white);
artist.addImage(evolution_collection_1);
artist.addImage(evolution_collection_2);
artist.addImage(evolution_collection_3);
artist.addImage(evolution_collection_4);
artist.addSizeAndPrice("3 x A5 (14.8x21.0cm)", 32, "price_1SSbrM2LxEhI4RHCzwHrwsuq");
// artist.addSizeAndPrice("3 x A5 (14.8x21.0cm)", 32, "price_1SSxMd2LxEhI4RHCvo93uRdn");
artist.addDetails(details);
artist.setId("holly-evolution-collection");
artist.addTestPriceId("price_1SLn542LxEhI4RHCi0ugkXqg");
artist.addDescription(`"These pieces were created when I was experimenting with trying to create a 'graffiti-like' effect from something digital. They have been fully created using code (specifically the programming language JavaScript - no, not AI !). 
    I used random noise data, called Perlin noise, and a lot of Maths to generate unique patterns in which the lines flow. The 4 sections show how the noise moves over time, 4 seconds apart, showing how a line may naturally move on its own (hence EVOLUTION)."`);

export default artist;
